// ============================================================
// Public School API Service
// ============================================================
// Calls backend public school configuration endpoint.
// Hostname resolution is handled entirely by the backend server based on request Host header.
// Frontend MUST NOT pass host, hostname, school_id, or organization_id.

import apiClient from './axios';

export const publicSchoolApi = {
  /**
   * Fetches public school configuration for current request hostname.
   * @returns {Promise<Object>} API response data
   */
  getPublicSchoolConfig: async () => {
    const response = await apiClient.get('/public/school', {
      headers: {
        accept: 'application/json',
      },
    });
    return response.data;
  },
};
